import {TABS_DELIVERED_SERVICES} from "../../../DeliveredServices/Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 08 de 05
 */
export const MODEL = {
    zoneId: null,
    search: '',
    limit: 10
};
